var UriBuilder = function() {};

UriBuilder.buildCreateDefinitionUri = function() {
    return "definitions/create";
};

UriBuilder.buildUriForSearchDomain = function(id, query) {
    return "domain/" + id + "/q=" + encodeURIComponent(query);
};

UriBuilder.buildUriForSimpleSearchRmImporterStats = function(query){
    return "importer-stats/q=" + encodeURIComponent(query);
};

UriBuilder.buildUriForImportDetailsWithSimpleSearch = function(statId, queryForLineRows){
    return "importer-stats/" + statId + "/q=" + encodeURIComponent(queryForLineRows);
};

UriBuilder.buildUriForAdvSearchRmImporterStats = function(query){
    return "importer-stats/aq=" + encodeURIComponent(query);
};

UriBuilder.buildUriForImportDetailsWithAdvancedSearch = function(statId, jsonStrQueryForLineRows){
    return "importer-stats/" + statId + "/aq=" + encodeURIComponent(jsonStrQueryForLineRows);
};

UriBuilder.buildUriForSimpleSearchDefinition = function(id, query, activeVisId) {
    let path = `definitions/${id}/q=${encodeURIComponent(query)}`;

    if(activeVisId){
        path += `&av=${activeVisId}`;
    }

    return path;
};

UriBuilder.buildUriForAdvSearchDefinition = function(id, query) {
    return "definitions/" + id + "/aq=" + encodeURIComponent(query);
};

UriBuilder.buildUriForInstance = function(id) {
    return "instance/" + id;
};

UriBuilder.buildBaseUriForInstanceFile = function(instanceId, fieldDefId) {
    return `recordm/instances/${instanceId}/files/${fieldDefId}/`;
};

UriBuilder.buildUriForGroupEditOnDataset = function(definitionId, ids) {
    return "instance/groupedit/" + definitionId + "/query=/ids=" + ids;
};

UriBuilder.buildUriForGroupEditOnQuery = function(definitionId, query) {
    return "instance/groupedit/" + definitionId + "/query=" + encodeURIComponent(query) + "/ids=";
};

UriBuilder.buildUriForCreateInstance = function(definitionId, instanceDataJsonStr) {
    const url = `instance/create/${definitionId}`;

    if(instanceDataJsonStr){
        return `${url}/data=${instanceDataJsonStr}`;
    }

    return url;
};

UriBuilder.buildUriForDuplicateInstance = function(instanceId) {
    return "instance/duplicate/" + instanceId;
};

UriBuilder.buildEditDefinitionUri = function(definitionId) {
    return "definitions/" + definitionId + "/edit";
};

UriBuilder.buildUriForImporter = function (defName, importerName){
    return `/recordm-importer/${importerName || "generic"}/file?def=${encodeURIComponent(defName)}`;
};

export default UriBuilder;
